/**
 * @internal
 */
import React from 'react';
import { MediaQueryProvider } from '@polestar/component-warehouse-react/contexts/mediaQuery';
import { InteractionProvider } from '@polestar/component-warehouse-react/contexts/interactionMode';
import PortalProvider from '@polestar/component-warehouse-react/contexts/portal';
import { MotionProvider } from '@polestar/component-warehouse-react/contexts/motion';
import { ModalProvider } from '@polestar/component-warehouse-react/contexts/modal';
import { HeaderProvider } from '@polestar/component-warehouse-react/components/header/HeaderContext';
import { NavigationDrawerProvider } from '@polestar/component-warehouse-react/components/navigation-drawer/NavigationDrawerContext';
import { SnackbarProvider } from '@polestar/component-warehouse-react/components/snackbar/SnackbarContext';
import SSRProvider from '@polestar/component-warehouse-react/contexts/ssr';
import DirectionProvider from '@polestar/component-warehouse-react/contexts/direction';
import ContentElementProvider from '@polestar/component-warehouse-react/contexts/contentElement';
import ConfigProvider from '@polestar/component-warehouse-react/contexts/config';
import ThemesProvider from '@polestar/component-warehouse-react/contexts/themes';
import { PointerReplaceProvider } from '@polestar/component-warehouse-react/components/pointer-replace/PointerReplaceContext';
import { FocusProvider } from '@polestar/component-warehouse-react/contexts/focus';
import { PrintProvider } from '@polestar/component-warehouse-react/contexts/print';
import { PopoverProvider } from '@polestar/component-warehouse-react/contexts/popover';
import { MegaMenuProvider } from '@polestar/component-warehouse-react/components/mega-menu/internal/MegaMenuContext';
/**
 * Default context providers
 * Contexts are nested, so the one at the top of ComponentContext is last to be nested
 */
const ComponentContexts = [
    // Component Providers
    [NavigationDrawerProvider],
    [SnackbarProvider],
    [HeaderProvider],
    [MegaMenuProvider],
    [PointerReplaceProvider],
    //
    [FocusProvider],
    [PortalProvider],
    [InteractionProvider],
    [MediaQueryProvider],
    [ModalProvider],
    [PopoverProvider],
    [MotionProvider],
    [PrintProvider],
    // @ts-ignore
    [ThemesProvider, 'theme', 'themes'],
    [DirectionProvider, 'initialDirection'],
    [SSRProvider],
    [ContentElementProvider],
    [ConfigProvider, 'config'],
];
/**
 * @internal
 */
export const ContextsProviders = ({ children, ...props }) => {
    return (React.createElement(React.Fragment, null, ComponentContexts.reduce((value, [Provider, ...propsToPick]) => {
        const providerProps = pickProps(props, propsToPick);
        return React.createElement(Provider, { ...providerProps }, value);
    }, children)));
};
const pickProps = (allProps, pickProps) => {
    const pickedProps = {};
    for (let i = 0; i < pickProps.length; i++) {
        const key = pickProps[i];
        if (key in allProps) {
            pickedProps[key] = allProps[key];
        }
    }
    return pickedProps;
};
